import { ERUDA_ALLOWED_URLS, type ErudaUrlMatcher } from "./eruda.config"

declare global {
  interface Window {
    // eruda se expone globalmente cuando se carga desde CDN
    eruda?: { init: () => void }
    __erudaInited?: boolean
  }
}

function matches(url: URL, matcher: ErudaUrlMatcher): boolean {
  if (typeof matcher === "string") {
    // Si empieza por "/", lo tratamos como path (ej: "/login")
    if (matcher.startsWith("/")) return url.pathname.startsWith(matcher)
    // Si parece una URL absoluta, comparamos contra href
    if (matcher.includes("://")) return url.href.startsWith(matcher)
    // En cualquier otro caso, buscamos coincidencia simple en href
    return url.href.includes(matcher)
  }
  if (matcher instanceof RegExp) return matcher.test(url.href)
  return matcher(url)
}

function shouldEnableEruda(): boolean {
  const url = new URL(window.location.href)
  return ERUDA_ALLOWED_URLS.some((m) => matches(url, m))
}

function loadScript(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${src}"]`)
    if (existing) return resolve()

    const script = document.createElement("script")
    script.src = src
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => reject(new Error(`Failed to load ${src}`))
    document.head.appendChild(script)
  })
}

export async function maybeInitEruda(): Promise<void> {
  if (typeof window === "undefined") return
  if (window.__erudaInited) return
  if (!shouldEnableEruda()) return

  await loadScript("https://cdn.jsdelivr.net/npm/eruda")
  window.eruda?.init()
  window.__erudaInited = true
}

